export default __webpack_public_path__ + "static/media/chain-eth.debaf25e.png";